import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Lenis from 'lenis';
import { CartProvider } from '@/context/CartContext';
import { WishlistProvider } from '@/context/WishlistContext';
import Cursor from '@/components/Cursor';
import Navbar from '@/components/Navbar';
import CartDrawer from '@/components/CartDrawer';
import Home from '@/pages/Home';
import Shop from '@/pages/Shop';
import Product from '@/pages/Product';
import Story from '@/pages/Story';
import CheckoutSuccess from '@/pages/CheckoutSuccess';
import CheckoutCancel from '@/pages/CheckoutCancel';
import Wishlist from '@/pages/Wishlist';
import Lookbook from '@/pages/Lookbook';
import VideoExperience from '@/pages/VideoExperience';
import { RunwaySculpture } from '@/components/home/RunwaySculpture';

gsap.registerPlugin(ScrollTrigger);

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
        return;
      }
    }
    window.scrollTo(0, 0);
    ScrollTrigger.refresh();
  }, [pathname, hash]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    lenis.on('scroll', ScrollTrigger.update);
    const tick = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(tick);
    gsap.ticker.lagSmoothing(0);
    return () => {
      gsap.ticker.remove(tick);
      lenis.destroy();
    };
  }, []);

  return (
    <WishlistProvider>
    <CartProvider>
      <BrowserRouter>
        <div className="relative min-h-screen overflow-x-clip bg-transparent font-jakarta text-[#1E1E1E] antialiased">
          <Cursor />
          <RunwaySculpture />
          <Navbar />
          <CartDrawer />
          <ScrollManager />
          <div className="relative z-10">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/products/:handle" element={<Product />} />
            <Route path="/story" element={<Story />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/looks" element={<Lookbook />} />
            <Route path="/v2" element={<VideoExperience />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/checkout/cancel" element={<CheckoutCancel />} />
          </Routes>
          </div>
          <Toaster
            theme="light"
            position="bottom-left"
            toastOptions={{
              style: {
                background: '#FFFFFF',
                border: '1px solid #D1D1D6',
                color: '#1E1E1E',
                borderRadius: '2px',
                fontFamily: 'Space Mono, monospace',
                fontSize: '11px',
                textTransform: 'uppercase',
                letterSpacing: '0.15em',
              },
            }}
          />
        </div>
      </BrowserRouter>
    </CartProvider>
    </WishlistProvider>
  );
}
